import { RootState } from "../../rootReducer";

export const selectIsSavingStressCheck = (state: RootState) =>
  state.newStressCheck.loading;
export const selectIsSaved = (state: RootState) => state.newStressCheck.saved;
export const selectSaveErrorMessage = (state: RootState) =>
  state.newStressCheck.error;
export const NewStressCheckDataResponse = (state: RootState) =>
  state.newStressCheck.newStressCheckResponse;
